import {
  isPickemType,
  PickemDetails,
  PickemDetailsBase,
} from "model/PickemDetails/PickemDetails";
import { nonUndefined } from "Utility";
import { mapBracketemDetails } from "./Bracketem/FsBracketemDetails";
import { mapRankemDetails } from "./Rankem/FsRankemDetails";
import { mapMatchemDetails } from "./Matchem/FsMatchemDetails";
import { mapPickemPointsPartitions } from "./FsPickemPointsPartition";
import { isFsBracketemDetails } from "db/model/pickemDetails/Bracketem/FsBracketemDetails";
import {
  FsPickemDetails,
  FsPickemDetailsBase,
} from "db/model/pickemDetails/FsPickemDetails";
import { isFsMatchemDetails } from "db/model/pickemDetails/Matchem/FsMatchemDetails";
import { isFsRankemDetails } from "db/model/pickemDetails/Rankem/FsRankemDetails";

export const mapPickemDetails = (
  fsModels: FsPickemDetails[],
  tournamentId: string
): PickemDetails[] => {
  return nonUndefined(fsModels.map((p) => mapPickemDetail(p, tournamentId)));
};

const mapPickemDetailsBase = (
  fsModel: FsPickemDetailsBase,
  tournamentId: string
): PickemDetailsBase | undefined => {
  if (
    !fsModel.leaderboardHeader ||
    !fsModel.name ||
    !fsModel.pickemId ||
    !fsModel.pickemType ||
    !isPickemType(fsModel.pickemType) ||
    !fsModel.segmentId
  ) {
    return undefined;
  }

  return {
    closeTimeMsOverride: fsModel.closeTimeMsOverride,
    driverPointsRules: !!fsModel.driverPointsRules
      ? mapPickemPointsPartitions(nonUndefined(fsModel.driverPointsRules))
      : undefined,
    earliestMatchTimeMs: fsModel.earliestMatchTimeMs,
    frozenRosters: fsModel.frozenRosters,
    groupId: fsModel.groupId,
    ignoreDrivers: fsModel.ignoreDrivers,
    ignoreMatchIds: fsModel.ignoreMatchIds,
    latestMatchTimeMs: fsModel.latestMatchTimeMs,
    leaderboardHeader: fsModel.leaderboardHeader,
    matchIds: fsModel.matchIds,
    message: fsModel.message,
    name: fsModel.name,
    numDriverPicks: fsModel.numDriverPicks ?? 0,
    openTimeMsOverride: fsModel.openTimeMsOverride,
    pickemId: fsModel.pickemId,
    pickemType: fsModel.pickemType,
    resultsMessage: fsModel.resultsMessage,
    segmentId: fsModel.segmentId,
    tournamentId: tournamentId,
  };
};

const mapPickemDetail = (
  fsModel: FsPickemDetails,
  tournamentId: string
): PickemDetails | undefined => {
  const base = mapPickemDetailsBase(fsModel, tournamentId);
  if (!base) {
    return undefined;
  }

  if (isFsBracketemDetails(fsModel)) {
    return mapBracketemDetails(fsModel, base);
  }

  if (isFsMatchemDetails(fsModel)) {
    return mapMatchemDetails(fsModel, base);
  }

  if (isFsRankemDetails(fsModel)) {
    return mapRankemDetails(fsModel, base);
  }

  return undefined;
};
